export * from './contentful'
export { default as Contentful } from './contentful'



// WEBPACK FOOTER //
// ./src/services/index.js